<!-- 
  详情页 - 入库记录
  props:
    id: 产品
  emit: 
    openDetail: 打开详情页
 -->
<template>
  <div class="instock-tab">
    <h1 v-if="specArray.length>1" class="theme"><i></i><span>产品规格</span></h1>
     <ul v-if="specArray.length>1" class="productCon listCPGG">
        <li v-for="(spec,index) in specArray" 
         :class="{active:index === tabNum}"
         @click="tabLi(spec.id,index)">
          {{spec.specification}}
        </li>
     </ul>
     <h1 class="theme"><i></i><span>入库单</span></h1>
      <el-table
        border
        :data="tableData"
        style="width: 95%">
        <el-table-column
          label="入库日期"
          width="180">
          <template slot-scope="scope">
            {{scope.row.instockTime}}
          </template>
        </el-table-column>
        <el-table-column
          label="入库类型">
          <template slot-scope="scope">
            {{scope.row.typeName}}
          </template>
        </el-table-column>
        <el-table-column
          label="入库单据"
          >
          <template slot-scope="scope">
             <a @click="openDetail(scope.row.id)">{{scope.row.sheetNo}}</a>
          </template>
        </el-table-column>
        <el-table-column
          label="入库仓库">
          <template slot-scope="scope">
            {{scope.row.warehouseName}}
          </template>
        </el-table-column>
        <el-table-column
          label="入库数量">
          <template slot-scope="scope">
            {{scope.row.productNum}}
          </template>
        </el-table-column>
    </el-table>
    <div class="pagination-wrapper clearfix" v-if="total>0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 30, 40]"
        layout="sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import * as api from 'src/api'
export default {
  created () {
    this.getTabCon()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      total: 0,
      pageSize: 10,
      currentPage: 1,
      spaceProId: '', // 选中的规格产品id
      specArray: [], // 规格数组
      tabNum: 0, // 多规格当前选中索引
      tableData: [] // 表格数据数组
    }
  },
  methods: {
    // 获取接口
    getTabCon () {
      let url = `/productApi/getChildProductList.html`
      let params = {
        productId: this.id
      }
      api.post(url, params, (data) => {
        this.specArray = data.childProductList // 规格数组
        if (data.childProductList.length === 1 || data.childProductList[0]) {
          this.spaceProId = data.childProductList[0].id
          this.getTableList(this.spaceProId)
        }
      })
    },

    // 多规格点击tab
    tabLi (id, index) {
      this.tabNum = index
      this.spaceProId = id
      this.getTableList(id)
    },

    // 请求表格数据
    getTableList (id) {
      let url = `/productStock/getInstock.html`
      let params = {
        productId: id,
        page: this.currentPage,
        pageSize: this.pageSize
      }
      api.post(url, params, (data) => {
        this.tableData = data.result
        this.total = data.pageHelper.rowsCount // 总条数
      })
    },

    // 每页所显示的条数变更
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableList(this.spaceProId)
    },

    // 当前分页变更
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableList(this.spaceProId)
    },

    // 打开详情
    openDetail (id) {
      this.$emit('openDetail', 'instock', id)
    }

  }
}
</script>
<style lang="less">
  .instock-tab{
    .el-table{margin: 15px auto;}
  }
</style>
<style lang="less" scoped>
  .instock-tab{
    padding:0 15px;
    .theme{background:#F1F6FE;line-height: 30px;font-size:13px;}
    .theme i{display:inline-block;width:8px;height:8px;background:#FF943E;margin:0 10px;}
    .productCon{
      margin:15px 0 0;
      margin-left: 28px;
      display: flex;
      flex-wrap: wrap;
      &.listCPGG li{padding:10px 10px;border:1px solid #ccc;cursor: pointer;
        margin-right:15px;border-radius: 2px;margin-bottom: 10px;}
      &.listCPGG li.active{border:1px solid #FF943E;background:#FF943E;color:#fff;}
    }
    .pagination-wrapper{width:100%;padding-top: 20px;}
    .pagination-wrapper .el-pagination {float:right;}
  }
</style>


// WEBPACK FOOTER //
// instock-tab.vue?0476c9bd